import * as React from "react";

import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";

import { useAppSelector } from "store/hooks";

const Statistics: React.FC = () => {
  const { transactions, users, banks, commission } = useAppSelector(
    (state) => state.home.statistics,
  );

  const items = [
    { value: transactions, text: "Оплат створено через сервіс" },
    { value: users, text: "Підприємців користуються щодня" },
    { value: banks, text: "Банків підтримують оплату" },
    { value: commission, text: "Комісія сервісу" },
  ];

  if (transactions <= 0) {
    return;
  }

  return (
    <Container sx={styles.section}>
      <Box sx={styles.grid}>
        {items.map((item, index) => (
          <Box key={index} sx={styles.cell}>
            <Typography variant="h2" color="primary" sx={styles.number}>
              {item.value.toLocaleString("uk-UA")}
            </Typography>
            <Typography>{item.text}</Typography>
          </Box>
        ))}
      </Box>
    </Container>
  );
};

const styles = {
  section: {
    paddingTop: "6px",
    paddingBottom: { xs: "40px", sm: "120px" },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "1px",
    backgroundColor: "#E5E5E5",
    "@media (min-width: 700px)": {
      gridTemplateColumns: "1fr 1fr",
    },
    "@media (min-width: 1199px)": {
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
    },
  },
  cell: {
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    textAlign: "center",
    padding: { xs: "20px 10px", lg: "0 10px" },
  },
  number: {
    width: "100%",
    textAlign: "center",
    marginBottom: 1.5,
    fontWeight: 700,
  },
};

export default Statistics;
